import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import "firebase/compat/auth";
import "firebase/compat/functions";
import firebaseJson from '../../inc/firebase.json';

const FirebaseAuth = firebase.initializeApp(firebaseJson.config);
const Firestore = FirebaseAuth.firestore();
const CloudFunctions = FirebaseAuth.functions();

// Route to the local Firebase Emulator Suite instead of the real cloud
// project when explicitly opted in via `npm run start:emulator`
// (REACT_APP_USE_EMULATORS=true). Never active in a normal build, so
// this can't accidentally point a deployed app at a local emulator.
// The eslint-disable comments are for a false positive: the
// react-hooks plugin flags any `use*` method call as if it were a
// React Hook, but these are plain Firebase SDK methods.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    FirebaseAuth.auth().useEmulator('http://127.0.0.1:9099', { disableWarnings: true });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    Firestore.useEmulator('127.0.0.1', 8082);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    CloudFunctions.useEmulator('127.0.0.1', 5001);
    // eslint-disable-next-line no-console
    console.warn('[dev] Using local Firebase emulators (Auth/Firestore/Functions).');

    // Test-only sign-in hook: lets an automated test agent authenticate
    // via a custom token (minted by a local admin script against the
    // emulator) instead of driving the real login form. Only wired up
    // in emulator mode, never in a normal build.
    // eslint-disable-next-line no-undef
    window.__testSignIn = (customToken) => FirebaseAuth.auth().signInWithCustomToken(customToken);
    // eslint-disable-next-line no-undef
    window.__testSignOut = () => FirebaseAuth.auth().signOut();
    // eslint-disable-next-line no-undef
    window.__testFirestore = Firestore;
    // eslint-disable-next-line no-undef
    window.__testAuth = FirebaseAuth;
}

export {FirebaseAuth, Firestore, CloudFunctions}